export const iconFontAwesomeAutomotiveCarOn = (
	<i className="fa-solid fa-car-on"></i>
);
